import { useGetCheckerMakerTemplateDetail } from '../../hooks/checker-maker-query/useGetCheckerMakerTemplateDetail';
import useCampaignParams from '../../hooks/useCampaignParams';
import { ChannelKeyEnum } from '../../shared/master-api.interface';

export const useGetTemplateDetail = (channelType: ChannelKeyEnum) => {
  const { channelId } = useCampaignParams();
  return useGetCheckerMakerTemplateDetail(channelType, channelId);
};
